// config/routeConfig.js

export const ROUTE_CONFIG = {
  // Optimization settings
  OPTIMIZATION: {
    MAX_STOPS_PER_ROUTE: 50,
    DEFAULT_SERVICE_TIME_MINUTES: 60,
    BUFFER_TIME_PERCENTAGE: 0.2,
    PACKING_TIME_MINUTES: 5,
    DAYS_TO_BUILD_AHEAD: 90,
    MAX_ROUTE_DISTANCE_MILES: 100,
    MAX_DAILY_HOURS: 8,
    OVERTIME_THRESHOLD_HOURS: 8,
    HEAVY_WEEK_THRESHOLD_HOURS: 40,
    IDEAL_DAILY_HOURS_MIN: 6,
    IDEAL_DAILY_HOURS_MAX: 8,
  },
  
  // Job frequencies
  FREQUENCIES: {
    REGULAR: ['Daily', 'Weekly', 'Bi-Weekly', 'Every Other Day (M-W-F)', 'Twice a Week'],
    SCHEDULED: ['Monthly', 'Quarterly', 'Semi-Annually', 'Annually', 'On-Demand', 'On Demand'],
    SPACING_DAYS: {
      'Monthly': 21,
      'Quarterly': 79,
      'Semi-Annually': 150,
      'Annually': 300,
      'Bi-Weekly': 14,
      'Weekly': 7,
      'Daily': 1
    }
  },
  
  // Map settings
  MAP: {
    DEFAULT_CENTER: { lat: 33.50547813946138, lng: -112.15212417301781 },
    DEFAULT_ZOOM: 9,
    OFFSET: 0.353, // Map offset for crew view
    OFFSET_UNASSIGNED: 0.2, // Map offset for unassigned view
    ZOOM_LEVELS: {
      OVERVIEW: 9,
      DETAIL: 12,
      CLOSE: 15
    },
    MARKER: {
      DEFAULT_COLOR: '#FF0000',
      SELECTED_COLOR: '#00FF00',
      CREW_ARROW_SCALE: 3,
      SITE_CIRCLE_SCALE: 6,
      ORDERED_CIRCLE_SCALE: 12
    }
  },
  
  // UI settings
  UI: {
    DEBOUNCE_DELAY: 300,
    MAX_SEARCH_RESULTS: 250,
    MAX_NEARBY_SITES: 10,
    CREW_LIST_HEIGHT: '60vh',
    SELECTED_CREW_HEIGHT: '45vh',
    ANIMATION_DURATION: 300,
    ERROR_DISPLAY_DURATION: 5000
  },
  
  // Cache settings
  CACHE: {
    ROUTE_TTL: 5 * 60 * 1000, // 5 minutes
    SITE_DETAILS_TTL: 10 * 60 * 1000, // 10 minutes
    CREW_HOURS_TTL: 2 * 60 * 1000, // 2 minutes
  },
  
  // API settings
  API: {
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000,
    BATCH_SIZE: 100
  },
  
  // Business rules
  BUSINESS_RULES: {
    WEEKDAYS: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    CREW_COLOR_PALETTE: [
      { backgroundColor: '#FF6B6B', textColor: '#FFFFFF' },
      { backgroundColor: '#4ECDC4', textColor: '#FFFFFF' },
      { backgroundColor: '#45B7D1', textColor: '#FFFFFF' },
      { backgroundColor: '#96CEB4', textColor: '#333333' },
      { backgroundColor: '#FECA57', textColor: '#333333' },
      { backgroundColor: '#DDA0DD', textColor: '#333333' },
      { backgroundColor: '#98D8C8', textColor: '#333333' },
      { backgroundColor: '#F7DC6F', textColor: '#333333' },
      { backgroundColor: '#85C1E9', textColor: '#333333' },
      { backgroundColor: '#F8B595', textColor: '#333333' }
    ]
  },
  
  // Error messages
  ERRORS: {
    ROUTE_FETCH_FAILED: 'Failed to load routes. Please try again.',
    ASSIGNMENT_FAILED: 'Failed to assign job. Please try again.',
    UNASSIGNMENT_FAILED: 'Failed to unassign job. Please try again.',
    INVALID_COORDINATES: 'Invalid location coordinates.',
    NO_CREWS_AVAILABLE: 'No crews available for assignment.',
    OPTIMIZATION_FAILED: 'Route optimization failed. Using default route.',
    NETWORK_ERROR: 'Network error. Please check your connection.'
  },
  
  // Success messages
  SUCCESS: {
    JOB_ASSIGNED: 'Job assigned successfully',
    JOB_UNASSIGNED: 'Job unassigned successfully',
    ROUTES_UPDATED: 'Routes updated successfully',
    CREW_SELECTED: 'Crew selected'
  }
};

// Helper function to get frequency spacing
export const getFrequencySpacing = (frequency) => {
  return ROUTE_CONFIG.FREQUENCIES.SPACING_DAYS[frequency] || 30;
};

// Helper function to check if frequency is regular
export const isRegularFrequency = (frequency) => {
  return ROUTE_CONFIG.FREQUENCIES.REGULAR.includes(frequency);
};

// Helper function to check if frequency is scheduled
export const isScheduledFrequency = (frequency) => {
  return ROUTE_CONFIG.FREQUENCIES.SCHEDULED.includes(frequency);
};

// Helper function to get crew color
export const getCrewColorConfig = (index) => {
  const colors = ROUTE_CONFIG.BUSINESS_RULES.CREW_COLOR_PALETTE;
  return colors[index % colors.length];
};
